import { render, staticRenderFns } from "./TalkizyIntro.vue?vue&type=template&id=1e2f4f40&scoped=true&"
import script from "./TalkizyIntro.vue?vue&type=script&lang=js&"
export * from "./TalkizyIntro.vue?vue&type=script&lang=js&"
import style0 from "./TalkizyIntro.vue?vue&type=style&index=0&id=1e2f4f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f4f40",
  null
  
)

export default component.exports